import { PlanungPermissionChecker } from '@bp/shared-planung-utils';
import { useRef } from 'react';
import { useAuthClaims } from './useAuthClaims';

export const usePermissionChecker = () => {
  const { pimAuthClaims } = useAuthClaims();
  const profile = pimAuthClaims.getProfile();
  const roles = pimAuthClaims.getRoles();
  const omniOrganization = pimAuthClaims.getOmniOrganization();

  const permissionChecker = useRef<PlanungPermissionChecker | null>(null);

  if (!profile || !roles || !omniOrganization) {
    console.warn('Insufficient claims for permission checker. Returning deny-all permission checker');
    permissionChecker.current = null;
  } else {
    permissionChecker.current = new PlanungPermissionChecker({
      profile,
      organization: pimAuthClaims.getOrganization(),
      roles: roles,
      user: pimAuthClaims.getUser(),
      omniOrganization,
      application: pimAuthClaims.getApplication(),
    });
  }

  return permissionChecker.current;
};
